import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { Brands, ProductTypeLookup } from 'shared/types';

export function useProductTypes(brand: Brands) {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading, isFetching } = useQuery<string[], Error>(
    ['producttypes'],
    () =>
      quoteService.getDropdownOptions<ProductTypeLookup>({
        brand,
        table: 'prodtypeoptions',
        optionColumn: 'producttype',
      }),
    {
      onError: error => {
        enqueueSnackbar(error.message, { variant: 'error' });
      },
      retry: false,
    }
  );
  return { types: data, isLoading, isFetching } as const;
}
